var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11ZM15.3891 6.90911C15.7657 7.31312 15.7434 7.94589 15.3394 8.32245L12.4133 11.0497L15.1405 13.9758C15.5171 14.3798 15.4948 15.0126 15.0908 15.3891C14.6868 15.7657 14.054 15.7434 13.6775 15.3394L10.9502 12.4133L8.0241 15.1405C7.62008 15.5171 6.98731 15.4948 6.61076 15.0908C6.23421 14.6868 6.25647 14.054 6.66048 13.6775L9.5866 10.9502L6.85938 8.0241C6.48283 7.62008 6.50509 6.98731 6.90911 6.61076C7.31312 6.23421 7.94589 6.25647 8.32245 6.66048L11.0497 9.5866L13.9758 6.85938C14.3798 6.48283 15.0126 6.50509 15.3891 6.90911Z",
    fill: "#8798AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePhoto);
export default __webpack_public_path__ + "static/media/close-photo.2df9c0f30d293041086f32cbe302b4fe.svg";
export { ForwardRef as ReactComponent };